module.exports = __webpack_public_path__ + "img/TCTB_Logo.71c5b9fe.svg";